import type { CartLine, Product } from '../types/menu';

type SelectedModifier = NonNullable<CartLine['modifiers']>[number];

export type ModifierGroupViolation = {
  groupIndex: number;
  groupName: string;
  minimum: number;
  maximum: number;
  selected: number;
  type: 'minimum' | 'maximum' | 'unavailable';
};

export function modifierGroupViolations(product: Product, selectedModifiers: SelectedModifier[] = []): ModifierGroupViolation[] {
  const violations: ModifierGroupViolation[] = [];
  for (const selected of selectedModifiers) {
    const matches = (product.modifier_groups ?? []).filter(group => (selected.groupId === undefined || selected.groupId === (group.id ?? '')) && group.items.some(item => item.productId === selected.productId));
    if (matches.length !== 1) violations.push({ groupIndex: 0, groupName: selected.name || 'Добавка', minimum: 0, maximum: 0, selected: selected.amount, type: 'unavailable' });
  }

  (product.modifier_groups ?? []).forEach((group, groupIndex) => {
    const allowed = new Set(group.items.map((item) => item.productId));
    const scoped = selectedModifiers.filter(item => {
      if (!allowed.has(item.productId)) return false;
      if (item.groupId !== undefined) return item.groupId === (group.id ?? '');
      return (product.modifier_groups ?? []).filter(candidate => candidate.items.some(option => option.productId === item.productId)).length === 1;
    });
    const selected = scoped
      .reduce((sum, item) => sum + Math.max(0, Number(item.amount ?? 0)), 0);
    const minimum = Math.max(0, Number(group.minQuantity ?? 0));
    const maximum = Math.max(minimum, Number(group.maxQuantity ?? 99));
    for (const item of group.items) {
      const amount = scoped.filter(choice => choice.productId === item.productId).reduce((sum, choice) => sum + choice.amount, 0);
      const itemMin = Math.max(0, Number(item.minQuantity ?? 0));
      const itemMax = Math.min(maximum, Number(item.maxQuantity ?? maximum));
      if (amount < itemMin || amount > itemMax) violations.push({ groupIndex, groupName: item.name, minimum: itemMin, maximum: itemMax, selected: amount, type: amount < itemMin ? 'minimum' : 'maximum' });
    }
    if (selected < minimum) violations.push({ groupIndex, groupName: group.name || 'Дополнения', minimum, maximum, selected, type: group.items.length ? 'minimum' : 'unavailable' });
    else if (selected > maximum) violations.push({ groupIndex, groupName: group.name || 'Дополнения', minimum, maximum, selected, type: 'maximum' });
  });
  return violations;
}

export const productNeedsConfiguration = (product: Product) => (product.modifier_groups ?? [])
  .some((group) => Number(group.minQuantity ?? 0) > 0 || group.items.some(item => Number(item.minQuantity ?? 0) > 0));
